import { IsOptional, IsString } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateClassRoleDto {
  @ApiPropertyOptional({ type: 'string', description: 'Code du rôle de classe' })
  @IsOptional()
  @IsString()
  code?: string

  @ApiPropertyOptional({ type: 'string', description: 'Nom du rôle de classe' })
  @IsOptional()
  @IsString()
  name?: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string
}
